import(/* webpackMode: "eager" */ "/vercel/path0/web/app/cartografico.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/components/carto/SpainMapMount.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/components/GeolocationButton.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/link.js");
